import React from 'react';
import { motion } from 'framer-motion';
import { Layers, FileText, CheckCircle, Sparkles } from 'lucide-react';
const levels = ['Principiante', 'Intermedio', 'Avanzado', 'Prenatal y Postnatal', 'Adultos Mayores', 'Yoga Terapéutico'];
export function SystemOverview() {
  return <section className="py-12 md:py-24 bg-yoga-purple-900 text-white relative overflow-hidden" data-id="element-266">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#D4AF37 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-267"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-268">
        <div className="max-w-4xl mx-auto text-center" data-id="element-269">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-270">
            <span className="text-yoga-gold font-bold tracking-widest uppercase text-xs md:text-sm mb-3 md:mb-4 block" data-id="element-271">
              RECURSOSFITNESS™ — @recursosfitness.ar
            </span>
            <h2 className="text-2xl md:text-5xl font-serif font-bold mb-4 md:mb-6" data-id="element-272">
              SISTEMA N°1 PARA PROFES DE YOGA EN ARGENTINA
            </h2>
            <div className="inline-block bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-4 md:px-6 py-1.5 md:py-2 text-base md:text-xl font-medium text-yoga-gold-300 mb-8 md:mb-12" data-id="element-273">
              MEGAPACK — SISTEMA COMPLETO
            </div>
          </motion.div>

          <div className="grid grid-cols-3 gap-3 md:gap-8 mb-8 md:mb-16" data-id="element-274">
            <motion.div className="bg-yoga-purple-800/50 border border-yoga-purple-700 p-4 md:p-8 rounded-xl md:rounded-2xl backdrop-blur-sm" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} data-id="element-275">
              <Layers className="w-8 h-8 md:w-12 md:h-12 text-yoga-gold mx-auto mb-2 md:mb-4" data-id="element-276" />
              <h3 className="text-base md:text-2xl font-bold mb-1 md:mb-2" data-id="element-277">
                6 Tomos + 6 Bonos
              </h3>
              <p className="text-yoga-purple-200 text-xs md:text-base" data-id="element-278">
                Todos los niveles. Todo resuelto.
              </p>
            </motion.div>

            <motion.div className="bg-yoga-purple-800/50 border border-yoga-purple-700 p-4 md:p-8 rounded-xl md:rounded-2xl backdrop-blur-sm" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} data-id="element-279">
              <FileText className="w-8 h-8 md:w-12 md:h-12 text-yoga-gold mx-auto mb-2 md:mb-4" data-id="element-280" />
              <h3 className="text-base md:text-2xl font-bold mb-1 md:mb-2" data-id="element-281">
                +360 páginas
              </h3>
              <p className="text-yoga-purple-200 text-xs md:text-base" data-id="element-282">
                De contenido estructurado
              </p>
            </motion.div>

            <motion.div className="bg-yoga-purple-800/50 border border-yoga-purple-700 p-4 md:p-8 rounded-xl md:rounded-2xl backdrop-blur-sm" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} data-id="element-283">
              <CheckCircle className="w-8 h-8 md:w-12 md:h-12 text-yoga-gold mx-auto mb-2 md:mb-4" data-id="element-284" />
              <h3 className="text-base md:text-2xl font-bold mb-1 md:mb-2" data-id="element-285">
                60+ clases
              </h3>
              <p className="text-yoga-purple-200 text-xs md:text-base" data-id="element-286">
                Completas y listas para dar
              </p>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="space-y-5 md:space-y-8" data-id="element-287">
            <p className="text-base md:text-xl text-yoga-purple-100 font-light max-w-3xl mx-auto leading-relaxed" data-id="element-288">
              Hatha · Vinyasa · Yin · Restaurativo · Yoga Terapéutico ·
              Poblaciones Especiales
              <br data-id="element-289" />
              <br data-id="element-290" />
              Planificación · Posturas · Progresión · Fidelización · Crecimiento
              Profesional
            </p>

            <div className="inline-flex items-center gap-2 bg-yoga-gold text-yoga-purple-950 font-bold px-4 md:px-6 py-2 md:py-3 rounded-full text-sm md:text-base" data-id="element-291">
              <Sparkles className="w-4 h-4 md:w-5 md:h-5" data-id="element-292" />
              Funciona desde hoy mismo en tu estudio o clases online
            </div>

            <div className="pt-6 md:pt-12 border-t border-yoga-purple-800" data-id="element-293">
              <h4 className="text-sm md:text-lg text-yoga-gold-300 font-semibold mb-4 md:mb-6 uppercase tracking-wider" data-id="element-294">
                Niveles y Enfoques Incluidos:
              </h4>
              <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-295">
                {levels.map((level, idx) => <span key={idx} className="bg-yoga-purple-800 px-3 py-1.5 md:px-4 md:py-2 rounded-lg text-xs md:text-sm font-medium border border-yoga-purple-600" data-id="element-296">
                    {level}
                  </span>)}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}